module.exports = __webpack_public_path__ + "img/RWBuild-Workshop-Collage-Promo-2.bb3aa315.png";